export const containerTheme = {
  MuiContainer: {
    variants: [
      {
        props: { variant: "smallSize" },
        style: ({ theme }) => ({
          [theme.breakpoints.up("md")]: {
            maxWidth: "910px",
            padding: "0 15px",
          },
        }),
      },
    ],
  },
};
